import React, { useState, useEffect, useRef } from 'react';
import TestiLikeComment from '../components/ui/TestiLikeComment';

const TYPES = ['Tous', 'Dessin', 'Peinture', 'Digital', 'Sculpture', 'Autre'];
const ANNEES = ['Toutes', '1970s', '1980s', '1990s', '2000s', '2009+'];

const COULEURS = {
  'Dessin': '#8b1a2a',
  'Peinture': '#6b3a5a',
  'Digital': '#1a4a6b',
  'Sculpture': '#3a6b1a',
  'Autre': '#6b5a1a',
  'dessin': '#8b1a2a',
  'peinture': '#6b3a5a',
  'gravure': '#6b5a1a',
  'sculpture': '#3a6b1a',
  'autre': '#6b5a1a',
};

function Drapeau({ code }) {
  if (!code) return null;
  return (
    <img
      src={`https://flagcdn.com/24x18/${code}.png`}
      alt={code}
      style={{ width: 18, height: 13, borderRadius: 2, objectFit: 'cover', verticalAlign: 'middle' }}
    />
  );
}

function CarteOeuvre({ o, onClick }) {
  const couleur = COULEURS[o.type] || '#8b1a2a';
  const typeLabel = o.type ? (o.type.charAt(0).toUpperCase() + o.type.slice(1)) : 'Autre';
  return (
    <div onClick={onClick} style={{
      background: '#fff',
      borderRadius: 12,
      border: '1.5px solid #e8d5d0',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'box-shadow 0.2s',
      boxShadow: '0 2px 8px rgba(139,26,42,0.06)',
    }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 24px rgba(139,26,42,0.13)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(139,26,42,0.06)'}
    >
      <div style={{
        height: 200,
        background: o.image ? 'none' : `linear-gradient(135deg, ${couleur}18, ${couleur}35)`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {(() => {
          let thumb = o.image;
          if (!thumb && o.video) thumb = o.video.replace(/\.(mp4|mov|avi|mkv|webm|m4v)(\?.*)?$/i, '.jpg');
          if (!thumb && o.videoUrl) { const yt = o.videoUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/); if (yt) thumb = 'https://img.youtube.com/vi/' + yt[1] + '/hqdefault.jpg'; }
          return thumb
            ? <img src={thumb} alt={o.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            : <div style={{ fontSize: 48, opacity: 0.3 }}>🎨</div>;
        })()}
        {(o.video || o.videoUrl) && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
            <div style={{ width: 46, height: 46, borderRadius: '50%', background: 'rgba(0,0,0,0.5)', color: '#fff', fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{'\u25b6'}</div>
          </div>
        )}
        {(o.video || o.videoUrl) && (
          <div style={{ position: 'absolute', bottom: 10, right: 10, background: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: 12, padding: '2px 9px', borderRadius: 20, display: 'flex', alignItems: 'center', gap: 4 }}>{'\u25b6'} Vidéo</div>
        )}
        <div style={{
          position: 'absolute', top: 10, left: 10,
          background: couleur,
          color: '#fff',
          fontSize: 12,
          fontWeight: 700,
          padding: '3px 10px',
          borderRadius: 20,
          letterSpacing: '0.05em',
        }}>{typeLabel}</div>
        {o.annee && (
          <div style={{
            position: 'absolute', top: 10, right: 10,
            background: 'rgba(255,255,255,0.9)',
            borderRadius: 20,
            padding: '3px 10px',
            fontSize: 12,
            color: '#6a5050',
            fontWeight: 600,
          }}>{o.annee}</div>
        )}
      </div>
      <div style={{ padding: '14px 16px' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', fontWeight: 400, marginBottom: 4 }}>
          {o.title || 'Sans titre'}
        </div>
        {o.description && (
          <div style={{ fontSize: 12, color: '#6a5050', marginBottom: 8, lineHeight: 1.5, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
            {o.description}
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Drapeau code={o.pays} />
            <span style={{ fontSize: 12, color: '#4a3030', fontWeight: 500 }}>{o.authorName}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, color: '#8b1a2a', fontWeight: 600 }}>
            <span>♥</span>
            <span>{o.likes?.length || 0}</span>
            {o.comments?.length > 0 && (
              <span style={{ marginLeft: 6, color: '#9a8080' }}>💬 {o.comments.length}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function ModalOeuvre({ o, onClose, token }) {
  const couleur = COULEURS[o.type] || '#8b1a2a';
  const typeLabel = o.type ? (o.type.charAt(0).toUpperCase() + o.type.slice(1)) : 'Autre';
  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(26,16,16,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 16, maxWidth: 640, width: '100%', maxHeight: '90vh', overflowY: 'auto', border: '2px solid #c49090', boxShadow: '0 20px 60px rgba(139,26,42,0.2)' }}>
        {o.image && (
          <div style={{ width: '100%', maxHeight: 360, overflow: 'hidden', borderRadius: '14px 14px 0 0' }}>
            <img src={o.image} alt={o.title} className="lb-img" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        )}
        <div style={{ padding: '24px 28px' }}>
          <button onClick={onClose} style={{ fontSize: 13, color: '#9a8080', background: 'none', border: 'none', cursor: 'pointer', marginBottom: 16, display: 'block' }}>← Retour</button>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 12 }}>
            <div>
              <h2 style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#1a1010', fontWeight: 400, marginBottom: 4 }}>{o.title || 'Sans titre'}</h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#6a5050' }}>
                <Drapeau code={o.pays} />
                <span>{o.authorName}</span>
                {o.authorCountry && <span>· {o.authorCountry}</span>}
                {o.annee && <span>· {o.annee}</span>}
              </div>
            </div>
            <div style={{ background: couleur, color: '#fff', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 20, whiteSpace: 'nowrap', flexShrink: 0 }}>{typeLabel}</div>
          </div>
          {o.description && (
            <p style={{ fontSize: 14, color: '#4a3030', lineHeight: 1.8, marginBottom: 20, fontStyle: 'italic', fontFamily: 'Georgia,serif' }}>{o.description}</p>
          )}
          {o.video && (
            <video src={o.video} controls style={{ width: '100%', borderRadius: 8, marginBottom: 20, background: '#000', maxHeight: 380 }} />
          )}
          {o.videoUrl && (() => {
            const u = o.videoUrl; let embed = '';
            const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
            const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
            if (yt) embed = 'https://www.youtube.com/embed/' + yt[1];
            else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1];
            return embed
              ? <div style={{ marginBottom: 20 }}><iframe title="video" src={embed} style={{ width: '100%', aspectRatio: '16 / 9', border: 'none', borderRadius: 8 }} allow="accelerometer; autoplay; encrypted-media; picture-in-picture; clipboard-write" allowFullScreen /></div>
              : <div style={{ marginBottom: 20 }}><a href={u} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#8b1a2a' }}>Voir la video</a></div>;
          })()}
          <TestiLikeComment
            testimonialId={o._id}
            initialLikes={o.likes?.length || 0}
                    likesList={o.likes || []}
            initialComments={o.comments || []}
            token={token}
            apiBase="/api/artwork"
          />
        </div>
      </div>
    </div>
  );
}

function ModalSoumettre({ onClose, token, currentUser }) {
  const PAYS_TO_CODE = { 'france': 'fr', 'espagne': 'es', 'japon': 'jp', 'algérie': 'dz', 'algerie': 'dz', 'royaume-uni': 'gb', 'belgique': 'be', 'inde': 'in', 'brésil': 'br', 'bresil': 'br', 'états-unis': 'us', 'etats-unis': 'us', 'allemagne': 'de', 'italie': 'it', 'maroc': 'ma', 'tunisie': 'tn', 'sénégal': 'sn', 'senegal': 'sn', 'canada': 'ca', 'australie': 'au', 'mexique': 'mx', 'argentine': 'ar', 'chili': 'cl', 'colombie': 'co', 'portugal': 'pt', 'pays-bas': 'nl', 'suisse': 'ch', 'autriche': 'at', 'pologne': 'pl', 'russie': 'ru', 'chine': 'cn', 'corée': 'kr', 'coree': 'kr', 'turquie': 'tr', 'égypte': 'eg', 'egypte': 'eg', 'afrique du sud': 'za', 'nigeria': 'ng', 'ghana': 'gh' };

  const [form, setForm] = useState({
    authorName: currentUser?.username || '',
    authorCountry: currentUser?.country || '',
    title: '',
    type: 'Dessin',
    annee: '',
    description: '',
    videoUrl: ''
  });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const videoRef = useRef();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const fileRef = useRef();

  const handleFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const handleVideoFile = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    setVideoFile(f);
    setVideoPreview(URL.createObjectURL(f));
  };

  const handleSubmit = async () => {
    if (!form.authorName || (!file && !videoFile && !form.videoUrl)) return alert('Indique ton nom et au moins une image ou une video.');
    setSending(true);
    const pays = PAYS_TO_CODE[form.authorCountry?.toLowerCase()] || form.authorCountry?.toLowerCase().slice(0, 2) || '';
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    fd.append('pays', pays);
    if (file) fd.append('image', file);
    if (videoFile) fd.append('video', videoFile);
    fd.append('rightsAccepted', 'true');
    const headers = token ? { Authorization: 'Bearer ' + token } : {};
    const res = await fetch('/api/artwork', { method: 'POST', headers, body: fd });
    setSending(false);
    if (res.ok) setSent(true);
  };

  return (
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(26,16,16,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '36px 32px', maxWidth: 480, width: '100%', border: '2px solid #c49090', boxShadow: '0 20px 60px rgba(139,26,42,0.2)', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 22, color: '#8b1a2a', marginBottom: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Partager mon œuvre
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, color: '#9a8080', cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <p style={{ fontSize: 13, color: '#6a5050', marginBottom: 20, lineHeight: 1.6 }}>Toutes les œuvres sont modérées avant publication.</p>
        {sent ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>✅</div>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#8b1a2a' }}>Œuvre soumise !</div>
            <p style={{ fontSize: 13, color: '#6a5050', marginTop: 8 }}>Elle sera publiée après modération.</p>
          </div>
        ) : (
          <>
            {[
              { label: 'Votre nom / pseudo', key: 'authorName', placeholder: 'Ex : Marie L.' },
              { label: 'Pays', key: 'authorCountry', placeholder: 'Ex : France' },
              { label: "Titre de l'œuvre", key: 'title', placeholder: 'Ex : Moonwalker' },
              { label: 'Année de création', key: 'annee', placeholder: 'Ex : 2023' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>{f.label}</label>
                <input value={form[f.key]} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} placeholder={f.placeholder}
                  style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010', boxSizing: 'border-box' }} />
              </div>
            ))}
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Type de création</label>
              <select value={form.type} onChange={e => setForm(p => ({ ...p, type: e.target.value }))}
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010' }}>
                {['Dessin', 'Peinture', 'Digital', 'Sculpture', 'Autre'].map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Description</label>
              <textarea rows={3} value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))}
                placeholder="Technique, dimensions, inspiration..."
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010', resize: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Photo de l'œuvre</label>
              <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />
              {preview ? (
                <div style={{ position: 'relative' }}>
                  <img src={preview} alt="" style={{ width: '100%', borderRadius: 8, maxHeight: 200, objectFit: 'cover' }} />
                  <button onClick={() => { setFile(null); setPreview(null); }}
                    style={{ position: 'absolute', top: 8, right: 8, background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '50%', width: 24, height: 24, cursor: 'pointer', fontSize: 12 }}>✕</button>
                </div>
              ) : (
                <div onClick={() => fileRef.current?.click()}
                  style={{ border: '2px dashed #c49090', borderRadius: 8, padding: '24px', textAlign: 'center', color: '#8b1a2a', fontSize: 13, cursor: 'pointer', background: '#fafaf8' }}>
                  📁 Cliquez pour sélectionner une image
                </div>
              )}
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Vidéo de l'œuvre (optionnel)</label>
              <input ref={videoRef} type="file" accept="video/*" style={{ display: 'none' }} onChange={handleVideoFile} />
              {videoPreview ? (
                <div style={{ position: 'relative' }}>
                  <video src={videoPreview} controls style={{ width: '100%', borderRadius: 8, maxHeight: 200, background: '#000' }} />
                  <button onClick={() => { setVideoFile(null); setVideoPreview(null); }}
                    style={{ position: 'absolute', top: 8, right: 8, background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '50%', width: 24, height: 24, cursor: 'pointer', fontSize: 12 }}>✕</button>
                </div>
              ) : (
                <div onClick={() => videoRef.current?.click()}
                  style={{ border: '2px dashed #c49090', borderRadius: 8, padding: '18px', textAlign: 'center', color: '#8b1a2a', fontSize: 13, cursor: 'pointer', background: '#fafaf8' }}>
                  Choisir un fichier mp4 (≤ 50 Mo)
                </div>
              )}
              <div style={{ textAlign: 'center', fontSize: 12, color: '#9a8080', margin: '8px 0' }}>— ou —</div>
              <input value={form.videoUrl} onChange={e => setForm(p => ({ ...p, videoUrl: e.target.value }))}
                placeholder="Lien YouTube / Vimeo"
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, color: '#1a1010', boxSizing: 'border-box', background: '#fafaf8' }} />
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <button onClick={onClose} style={{ flex: 1, padding: '11px', borderRadius: 8, border: '2px solid #c49090', background: '#fff', color: '#8b1a2a', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>Annuler</button>
              <button onClick={handleSubmit} disabled={sending}
                style={{ flex: 2, padding: '11px', borderRadius: 8, border: 'none', background: sending ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>
                {sending ? 'Envoi...' : 'Soumettre mon œuvre'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default function Art() {
  const token = localStorage.getItem('mjtoken');
  const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
  const [typeActif, setTypeActif] = useState('Tous');
  const [anneeActive, setAnneeActive] = useState('Toutes');
  const [tri, setTri] = useState('recent');
  const [oeuvres, setOeuvres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [oeuvreOuverte, setOeuvreOuverte] = useState(null);

  const fetchOeuvres = () => {
    setLoading(true);
    fetch('/api/artwork')
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setOeuvres(data); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchOeuvres(); }, []);

  const filtrees = oeuvres
    .filter(o => typeActif === 'Tous' || o.type === typeActif || o.type?.toLowerCase() === typeActif.toLowerCase())
    .filter(o => {
      if (anneeActive === 'Toutes') return true;
      const a = parseInt(o.annee);
      if (anneeActive === '1970s') return a >= 1970 && a < 1980;
      if (anneeActive === '1980s') return a >= 1980 && a < 1990;
      if (anneeActive === '1990s') return a >= 1990 && a < 2000;
      if (anneeActive === '2000s') return a >= 2000 && a < 2009;
      if (anneeActive === '2009+') return a >= 2009;
      return true;
    })
    .sort((a, b) => tri === 'likes' ? (b.likes?.length || 0) - (a.likes?.length || 0) : new Date(b.createdAt) - new Date(a.createdAt));

  const btnFiltre = (actif, onClick, label) => (
    <button onClick={onClick} style={{
      padding: '7px 14px', borderRadius: 8,
      border: actif ? '2px solid #8b1a2a' : '2px solid #e8d5d0',
      background: actif ? '#8b1a2a' : '#fff',
      color: actif ? '#fff' : '#4a3030',
      fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
    }}>{label}</button>
  );

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh', fontFamily: 'Arial,sans-serif' }}>
      <div style={{ background: '#fff', padding: '36px 40px 28px', borderBottom: '2px solid #c49090' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', marginBottom: 6, fontWeight: 700 }}>ART DES FANS</div>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
            <div>
              <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 30, color: '#1a1010', fontWeight: 400, marginBottom: 8 }}>
                L'amour des fans, <em style={{ color: '#8b1a2a', fontStyle: 'italic' }}>mis en art</em>
              </h1>
              <p style={{ fontSize: 13, color: '#4a3030', lineHeight: 1.8, maxWidth: 520 }}>
                Dessins, peintures, sculptures, créations numériques… Des artistes du monde entier rendent hommage à Michael à travers leurs œuvres.
              </p>
            </div>
            <button onClick={() => setShowModal(true)} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 10, padding: '12px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}>
              🎨 Partager mon œuvre
            </button>
          </div>
          <div style={{ display: 'flex', gap: 28, marginTop: 20 }}>
            {[
              { n: oeuvres.length, label: 'œuvres' },
              { n: oeuvres.reduce((s, o) => s + (o.likes?.length || 0), 0), label: 'appréciations' },
              { n: new Set(oeuvres.map(o => o.pays).filter(Boolean)).size, label: 'pays représentés' },
            ].map(({ n, label }) => (
              <div key={label}>
                <span style={{ fontSize: 22, fontWeight: 700, color: '#8b1a2a', fontFamily: 'Georgia,serif' }}>{n}</span>
                <span style={{ fontSize: 12, color: '#6a5050', marginLeft: 5 }}>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ background: '#f5eeeb', borderBottom: '2px solid #c49090', padding: '16px 40px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: '#1a1010', fontWeight: 700, minWidth: 60 }}>Type :</span>
            {TYPES.map(t => btnFiltre(typeActif === t, () => setTypeActif(t), t))}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 13, color: '#1a1010', fontWeight: 700, minWidth: 60 }}>Époque :</span>
            {ANNEES.map(a => btnFiltre(anneeActive === a, () => setAnneeActive(a), a))}
            <div style={{ marginLeft: 'auto' }}>
              <select value={tri} onChange={e => setTri(e.target.value)} style={{ padding: '7px 12px', borderRadius: 8, border: '2px solid #c49090', background: '#fff', color: '#4a3030', fontSize: 13, cursor: 'pointer' }}>
                <option value="recent">Plus récent</option>
                <option value="likes">Plus aimé</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 40px' }}>
        {loading && (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#9a8080', fontSize: 14 }}>Chargement…</div>
        )}
        {!loading && filtrees.length === 0 && (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#8b1a2a', fontSize: 15 }}>
            {oeuvres.length === 0 ? 'Aucune œuvre publiée pour l\'instant. Soyez le premier !' : 'Aucune œuvre pour ces filtres.'}
          </div>
        )}
        {!loading && filtrees.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 24 }}>
            {filtrees.map(o => <CarteOeuvre key={o._id} o={o} onClick={() => setOeuvreOuverte(o)} />)}
          </div>
        )}
        <div style={{ marginTop: 48, padding: '28px 32px', background: '#fff', border: '2px solid #c49090', borderRadius: 14, textAlign: 'center' }}>
          <div style={{ fontSize: 28, color: '#8b1a2a', marginBottom: 8 }}>"</div>
          <p style={{ fontFamily: 'Georgia,serif', fontSize: 17, color: '#3a2020', lineHeight: 1.7, fontStyle: 'italic' }}>
            The greatest education in the world is watching the masters at work.
          </p>
          <div style={{ fontSize: 12, color: '#8b1a2a', marginTop: 10, fontWeight: 600, letterSpacing: '0.1em' }}>— MICHAEL JACKSON</div>
        </div>
      </div>

      {oeuvreOuverte && <ModalOeuvre o={oeuvreOuverte} onClose={() => setOeuvreOuverte(null)} token={token} />}
      {showModal && <ModalSoumettre onClose={() => { setShowModal(false); fetchOeuvres(); }} token={token} currentUser={currentUser} />}
    </div>
  );
}
